module.exports = __webpack_public_path__ + "img/logo.17b9259f.png";